import { render, staticRenderFns } from "./multiSupplierPurchaseEdit.vue?vue&type=template&id=4bdb8367&scoped=true&"
import script from "./multiSupplierPurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./multiSupplierPurchaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./multiSupplierPurchaseEdit.vue?vue&type=style&index=0&id=4bdb8367&lang=less&scoped=true&"
import style1 from "./multiSupplierPurchaseEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb8367",
  null
  
)

component.options.__file = "multiSupplierPurchaseEdit.vue"
export default component.exports